import React from "react"

import Button from "../../../../../design-system/button"
import Header from "../../../../../design-system/header"
import Label from "../../../../../design-system/label"
import Modal from "../../../../../design-system/modal"
import * as styles from "./index.module.scss"

type Input = {
  label: string
  node: React.ReactNode
}

interface Props {
  open: boolean
  onClose: () => void
  inputs: Input[]
}

function CatalogFiltersModal({ open, onClose, inputs }: Props) {
  return (
    <Modal open={open} onClose={onClose} menu>
      <Header as="h3" variant="1">
        More Filters
      </Header>
      <div className={styles.inputsContainer}>
        {inputs.map(({ label, node }) => (
          <div key={label} className={styles.inputLabelContainer}>
            <Label>{label}</Label>
            {node}
          </div>
        ))}
      </div>
      <Button fullWidth onClick={onClose}>
        Filter
      </Button>
    </Modal>
  )
}

export default CatalogFiltersModal
